import React from 'react';

import { useQuery, Loading, Error, SelectInput, required } from 'react-admin';


const GetSerialNum = (props) => {
    var ins_id = props && props.ins_id;
    //console.log(ins_id)
    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'serialnumbers',
        payload:  {
            filter: {'id': ins_id},
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'serial_num', order: 'ASC' }
        }
    });
 
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //controlnums = data;
    return (
        <SelectInput source="serial_num" label='' choices={data} required/>
    );
};

export default GetSerialNum;